export enum ExpertChildTab {
  User = 'settings/expert/agent',
  Group = 'settings/expert/group',
  Organization = 'settings/expert/organization',
}
export enum Role {
  Agent = 'agent',
  Supervisor = 'supervisor',
  Administrator = 'administrator',
  TeamLeader = 'team_leader',
}
export enum RoleContext {
  Agent = 'Chuyên viên',
  Supervisor = 'Supervisor',
  Administrator = 'Administrator',
  TeamLeader = 'Trưởng bộ phận',
}

export const ExpertTabList = [
  {
    id: ExpertChildTab.User,
    title: 'Chuyên viên',
  },
  {
    id: ExpertChildTab.Group,
    title: 'Bộ phận',
  },
  {
    id: ExpertChildTab.Organization,
    title: 'Tổ chức',
  },
];
export function getCurrentTab(url) {
  let tab = '';
  Object.keys(ExpertChildTab).forEach(s => {
    if (url.includes(ExpertChildTab[s])) {
      tab = ExpertChildTab[s];
    }
  });
  return tab;
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/setting/expert/expert.const.ts